module.exports = __webpack_public_path__ + "img/wynnlasvegas-mx.e6d70e22.jpg";